import React, { ChangeEvent } from 'react';

interface Props {
  id: string;
  label: string;
  options: Option[];
  value?: string;
  disabled?: boolean;
  required?: boolean;
  multiple?: boolean;
  width?: string;
  fontSize?: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  description?: string;
}

interface Option {
  label: string;
  value: string;
  selected?: boolean;
}

const DropdownField: React.FC<Props> = ({
  id,
  label,
  options,
  value,
  disabled = false,
  required = false,
  multiple,
  width = '300px',
  fontSize = '16px',
  onChange,
  description,
}) => (
  <React.Fragment>
    <div className="form-group">
      <label htmlFor={id}>
        {label} {required ? '*' : ''}
      </label>
      {description && <p>{description}</p>}
      <select
        name={id}
        id={id}
        value={value}
        disabled={disabled}
        onChange={onChange}
        multiple={multiple}
      >
        {options.map((option, index) => (
          <option
            key={`${id}-${index}`}
            value={option.value}
            selected={option.selected}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
    {/* language=CSS */}
    <style jsx>{`
      .form-group {
        box-sizing: border-box;
        margin-bottom: 1rem;
        position: relative;
        width: ${width};
      }

      .form-group label {
        font-family: 'Volvo Novum', sans-serif;
        font-size: ${fontSize};
        transition: all 100ms ease-in-out;
        cursor: default;
      }

      .form-group select {
        font-family: 'Volvo Novum', sans-serif;
        background: transparent;
        border-color: #707070;
        border-width: 1px;
        font-size: 14px;
        outline: 0;
        padding: 0.25rem 0 0.5rem;
        width: 100%;
      }

      p {
        font-family: 'Volvo Novum', sans-serif;
        margin: 0 0 6px;
        font-size: 14px;
        font-weight: 400;
      }
    `}</style>
  </React.Fragment>
);

export default DropdownField;
